export const FEATURE_CODE = 'featureCode';
